// extracted by mini-css-extract-plugin
export default {"lds":"preloader_lds__djido","lds-facebook":"preloader_lds-facebook__maOF7"};